// extracted by mini-css-extract-plugin
export var black = "_15-6";
export var brand = "_15-1";
export var ddefault = "_15-0";
export var error = "_15-3";
export var gray = "_15-2";
export var highContrast = "_15-8";
export var outline = "_15-7";
export var success = "_15-5";
export var warning = "_15-4";